import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import './StudentPerformanceSquare.scss';
import messages from './reportsMessages';

const StudentPerformanceSquare = (props) => {
  let auxReturn = '';

  if (props.percentGrade !== undefined) {
    auxReturn = props.percentGrade;
  } else if (props.correctAlternative !== undefined) {
    auxReturn = props.correctAlternative;
  } else if (props.percentHits !== undefined) {
    auxReturn = props.isTRI ? props.percentHits : `${parseInt(props.percentHits)}%`;
  } else if (props.avg !== undefined) {
    auxReturn = props.avg;
  }

  return (
    <div
      id={props.idQuestion}
      className="student-performance-square"
      style={{ textAlign: 'center' }}
    >
      <button
        type="button"
        onClick={props.onClick}
        style={{
          cursor: props.idQuestion && !props.notClickable ? 'pointer' : 'default',
          marginBottom: '10px',
        }}
        disabled={props.notClickable}
      >
        <div
          className="square"
          style={{
            backgroundColor: props.color,
            width: props.size,
            height: props.size,
            margin: 'auto',
          }}
        >
          {props.idQuestion ? (
            <div style={{ textAlign: 'center' }}>
              <div className="questionCard-position" style={{ fontSize: '14px' }}>
                Q{props.position}
              </div>
              <div className="questionCard-hits" style={{ fontSize: '40px' }}>
                {props.isTRI ? parseInt(props.percentHits) : `${parseInt(props.percentHits)}%`}
              </div>
              <div className="questionCard-alternative" style={{ fontSize: '12px' }}>
                {props.intl.formatMessage(messages.correctAlternative)} :{' '}
                <b>{props.correctAlternative}</b>
              </div>
              <div className="questionCard-discipline" style={{ fontSize: '12px' }}>
                {props.curricularComponent}
              </div>
            </div>
          ) : (
            <span style={{ width: props.isTRI ? '51px' : '41px' }}>{auxReturn}</span>
          )}
        </div>
        <span className="label">{props.fullname || props.name || props.studentName}</span>
      </button>
    </div>
  );
};

StudentPerformanceSquare.propTypes = {};

StudentPerformanceSquare.defaultProps = {
  size: 70,
  // isPercentage: true,
};

export default injectIntl(StudentPerformanceSquare);
